import {
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE,
  USER_LOGGED_IN_STATUS
} from '../../../constants/utils/analytics.constant';
import {
  ClickEventAnalytics,
  PageLoadErrorAnalytics,
  PageLoadLoginAnalytics
} from '../../../models/utils/analytics.interfaces';

export class LoginStatusAnalyticsHelper {
  static processLoginAnalytics(
    analytics: PageLoadErrorAnalytics | PageLoadLoginAnalytics
  ): PageLoadErrorAnalytics | PageLoadLoginAnalytics {
    const options = {
      [ANALYTICS_EVENTS.PAGE_LOAD_LOGIN]: () => {
        if ((analytics as PageLoadErrorAnalytics).error == undefined) {
          const pageName = (analytics as PageLoadLoginAnalytics).page.info
            .page_name;
          (
            analytics as PageLoadLoginAnalytics
          ).page.info.page_name = `dal:skymiles:${pageName}`;
        }
      },

      [ANALYTICS_EVENTS.ERROR]: () => {
        if ((analytics as PageLoadErrorAnalytics).error.type !== '') {
          const pageName = (analytics as PageLoadErrorAnalytics).page.info
            .page_name;
          (
            analytics as PageLoadErrorAnalytics
          ).page.info.page_name = `dal:${pageName}`;
        }
      }
    };

    const action =
      analytics.event === ANALYTICS_EVENTS.PAGE_LOAD_LOGIN
        ? ANALYTICS_EVENTS.PAGE_LOAD_LOGIN
        : ANALYTICS_EVENTS.ERROR;

    options[action]();
    return analytics;
  }

  static createLoginStatusAnalytics(
    loggedInStatus: boolean,
    errorCode?: string
  ): ClickEventAnalytics {
    const eventDetail = this.getLoggedInStatusString(loggedInStatus);

    return {
      event: ANALYTICS_EVENTS.CLICK,
      event_detail:
        eventDetail === USER_LOGGED_IN_STATUS.LOGIN_FAILURE
          ? USER_LOGGED_IN_STATUS.LOGIN_FAILURE
          : eventDetail,
      click: {
        name: this.getLoggedInStatusString(loggedInStatus),
        type: EVENT_CLICK_TYPE.BUTTON,
        page_section: 'header:login',
        action: this.getLoggedInStatusString(loggedInStatus)
      },
      user: {
        attributes: {
          is_logged_in: loggedInStatus
            ? USER_LOGGED_IN_STATUS.AUTHENTICATED
            : USER_LOGGED_IN_STATUS.UNAUTHENTICATED
        }
      },
      ...this.getErrorObject(eventDetail, errorCode)
    };
  }

  private static getErrorObject(
    eventDetail: string,
    errorCode?: string
  ): { error?: { type: string; code: string; message: string } } {
    return eventDetail === USER_LOGGED_IN_STATUS.LOGIN_FAILURE && errorCode
      ? {
          error: {
            type: 'home page load error',
            code: errorCode,
            message: USER_LOGGED_IN_STATUS.LOGIN_AUTHENTICATION_FAILED
          }
        }
      : {};
  }

  static getLoggedInStatusString(loggedInStatus: boolean): string {
    return loggedInStatus
      ? USER_LOGGED_IN_STATUS.LOGIN_SUCCESS
      : USER_LOGGED_IN_STATUS.LOGIN_FAILURE;
  }
}
